<script setup lang="ts">
/*
 * @file A wrapper around OzContainedButton specifically for belt color schemes.
 * This component is meant for use in the Profile Page as a Primary button associated with the belt color.
 */
import type { BeltColor } from '@@/bits/belt_colors'
import OzContainedButton, {
  OzContainedButtonColorScheme,
  OzContainedButtonSizePreset,
} from '@@/library/v4/components/OzContainedButton.vue'
import { computed } from 'vue'

const props = defineProps<{
  text: string
  beltColor?: BeltColor
}>()

const xBeltColorSignUpButton = computed(() => {
  return props.beltColor && props.beltColor !== 'white'
})

const beltColorClasses = computed(() => {
  switch (props.beltColor) {
    case 'yellow':
      return [
        // Base
        'bg-[#FFAA00]',
        'text-light-text-100 dark:text-dark-text-100',
        // Hovered
        'hover-hover:hover:bg-[#EB9C00]',
      ]
    case 'green':
      return [
        // Base
        'bg-[#12B800]',
        'text-light-text-100',
        // Hovered
        'hover-hover:hover:bg-[#11A900]',
      ]
    case 'blue':
      return [
        // Base
        'bg-[#1F88FF]',
        'text-light-text-100',
        // Hovered
        'hover-hover:hover:bg-[#1D7DEB]',
      ]
    case 'red':
      return [
        // Base
        'bg-[#E52250]',
        'text-light-text-100',
        // Hovered
        'hover-hover:hover:bg-[#D31F4A]',
      ]
    case 'black':
      return [
        // Base
        'bg-light-ui-100',
        'text-dark-text-100',
        // Hovered
        'hover-hover:hover:bg-[#EBEBEB]',
      ]
    default:
      return []
  }
})
</script>

<script lang="ts">
export { OzContainedButtonSizePreset } from '@@/library/v4/components/OzContainedButton.vue'
export default {}
</script>

<template>
  <OzContainedButton
    :class="xBeltColorSignUpButton ? beltColorClasses : undefined"
    href="/auth/signup"
    :text="text"
    :dark-mode="beltColor === 'black' ? true : 'auto'"
    :color-scheme="xBeltColorSignUpButton ? OzContainedButtonColorScheme.Bare : OzContainedButtonColorScheme.Secondary"
    :size-preset="OzContainedButtonSizePreset.H32px"
  />
</template>
